<template>
    <v-autocomplete
      ref="autocomplete"
      :label= "label"
      :class= "uniqueClass + ' content-list-'+autoCompleteId"
      v-model= "selectedContent"
      :items= "lists"
      :item-text= "itemText"
      :item-value= "itemValue"
      :disabled= "disabled"
      :search-input.sync= "searchString"
      :no-data-text= "loading ? 'Loading...' : noDataText"
      :outlined = 'outlined'
      :attach= "attach"
      :multiple= "multiple ? true :false"
      :return-object= "returnObject"
      :clearable= "clearable"
      :loading= "isLoading"
      :rules= "rules"
      @change= "onChange"
      @focus= "focussed()"
      @blur= "blurred()"
    />
  </template>
  <script>
  export default {
    name: "AutoComplete",
    props: {
        label:{
            type: String,
            default : () => ''
        },
        uniqueClass:{
            type: String,
            default : () => ''
        },
        itemText:{
            type: String,
            default : () => 'name'
        },
        itemValue:{
            type: String,
            default : () => 'id'
        },
        noDataText:{
            type: String,
            default : () => 'No data available'
        },
        outlined:{
            type: Boolean,
            default : () => true
        },
        attach:{
            type: Boolean,
            default : () => true
        },
        clearable:{
            type: Boolean,
            default : () => true
        },
        loading:{
            type: Boolean,
            default : () => false
        },
        rules:{
            type: Array,
            default : () => []
        },
        selection: {
            type: [Object, Number],
            default: () => null,
        },
        disabled: {
            type: Boolean ,
            default: () => false,
        },
        apiName:{
            type:  Function
        },
        responseName:{
            type: String,
            default : () => ''  
        },
        perPage:{
            type: Number,
            default: () => 10,
        },
        returnObject:{
            type : Boolean,
            default : () => false
        },
        multiple:{
            type : Boolean,
            default : () => false
        },
        dataList : {
          type: Array,
          default : () => []
        },
        sortBy:{
          type: String,
          default:() => ''
        },
        sortValue:{
          type: String,
          default: () =>''
        },
        noFolder: {
          type: Boolean,
          default: () => false
        },
        params: {
          type: Object,
          default: () => {}
        }
    },
    data() {
      return {
        selectedContent: this.selection,
        selectedObject: {},
        pageNumber: 1,
        totalPage: 0,
        searchString: null,
        searchStringName: null,
        listComplete: false,
        debounceSearch: "",
        itemSelectionEvent: false,
        isFocussed: false,
        isBlurred: false,
        isLoading : this.loading,
        lists: this.dataList,
        autoCompleteId : new Date().getTime()
      };
    },
    watch: {
      searchString(newVal) {
        if(!this.apiName) return;

        if (this.itemSelectionEvent) {
          // This is truthy when a user selects a content and that triggers a change in textbox value
          this.itemSelectionEvent = false;
          return;
        }
        // Clearing the user's selection when search string is completely cleared
        if(newVal == '' || newVal == null){
          this.selectedObject = {};
          this.selectedContent = null;
        }
        if (this.debounceSearch) {
          clearTimeout(this.debounceSearch);
        }
        this.debounceSearch = setTimeout(() => {
          /*** In case inbuilt autocomplete filter is required */
          if(!this.responseName) return;
          
          if (!this.isFocussed) return;
          this.pageNumber = 1;
          this.searchStringName = newVal;
          this.getLists();
          this.scrollToTop();
        }, 300);
      },
      selectedContent(newVal) {
        this.$emit("update:selection", newVal);
      },
    },
    mounted() {
      if(!this.apiName) return;
      this.addContentListener();
      this.getLists();
      this.saveObject();
    },
    methods: {
      saveObject(){
        this.selectedObject = this.lists.filter(val => {
            if(!this.returnObject && val[this.itemValue] == this.selectedContent)
              return val
            else if (val[this.itemValue] == this.selectedContent[this.itemValue])
              return val
          }
        )[0];
      },
      focussed() {
        this.isFocussed = true;
        if (this.isBlurred) {
          this.isBlurred = false;
        }
      },
      blurred() {
        if(!this.apiName) return;
        this.isBlurred = true;
        this.scrollToTop();
        if(!this.selectedContent){
          this.pageNumber = 1;
          this.searchStringName = this.responseName !== '' ? this.searchString : null;
          this.getLists();
        }else{
          if(this.searchString.length>0 
          && this.selectedObject.name !== this.searchString 
          ){
            
            if(this.selectedObject.name.indexOf(this.searchString)>=0){
              this.itemSelectionEvent = true;
              this.searchString = this.selectedObject.name;
            }else{
              this.selectedObject = {};
              this.selectedContent = null;
            }
          }
        }
      },
      addContentListener() {
        this.selectorClass =
          ".content-list-" + this.autoCompleteId + " .v-autocomplete__content";
        var el = document.querySelector(this.selectorClass);
        /** add scroll event **/
        if (el) {
          el.addEventListener("scroll", this.onContentScroll);
        }
      },
      onContentScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
        if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
          if (!this.listComplete && this.lists.length>0) {
            this.pageNumber += 1;
            this.getLists();
          }
        }
      },
      getLists() {
        this.isLoading = true;
        const payload = {
          page: this.pageNumber,
          per_page: this.perPage,
          name: this.searchStringName
        };
        if(this.sortBy && this.sortValue){
          payload.sort_by = this.sortBy;
          payload.method = this.sortValue;
        }
        if(this.noFolder){
          payload.no_folder = true;
        }

        /*** manage params in payload */
        if(this.params){
          Object.entries(this.params).forEach(([key, value]) => {
            payload[key] = value;
          });
        }
                
        this.apiName({ params: payload }).then((response) => {
          let res = response.data.data ? response.data.data : response.data ? response.data : {} 
          if(this.pageNumber === 1) {
            this.lists = [];
          }
          if(this.responseName === ''){
            this.lists = [
              ...this.lists,
              ...res,
            ];
          }
          else{
            this.lists = [
              ...this.lists,
              ...(res[this.responseName] ? res[this.responseName] : []),
            ];
          }
          
          // Pushing the selected object explicitly if it doesn't exist in search response.
          if(this.selectedObject && this.selectedObject[this.itemValue]){
            let index = this.lists.findIndex(value => value[this.itemValue] === this.selectedObject[this.itemValue]);
            if(index<0) this.lists.splice(0,0,this.selectedObject);
          }
          if(this.responseName !== ''){
            this.totalPage = Math.ceil(res.meta.count/this.perPage);
            this.listComplete = this.totalPage <= this.pageNumber ? true : false;
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
      },
      onChange(){
        this.saveObject(); 
        if(this.selectedObject.name !== this.searchString ){
          this.itemSelectionEvent = true; 
        }
        this.scrollToTop();
      },
      scrollToTop(){
        var el = document.querySelector(".content-list-" + this.autoCompleteId + " .v-autocomplete__content");
        if(el){
          el.scrollTop =0;
        }
      },
    },
  };
  </script>
  
